var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Radio from './radio.js';
import Copy from './copy.js';
export const AsideContentCallout = styled(Copy).withConfig({ displayName: "brc-AsideContentCallout", componentId: "brc-jvcucf" }) `
  position: absolute;
  background-color: ${({ theme }) => theme.mermaidGreen200};
  padding: 4px 8px;
  border-radius: 12px;
`;
const ToggleContainer = styled.div.withConfig({ displayName: "brc-ToggleContainer", componentId: "brc-wjn1n8" }) `
  display: flex;
  padding: 16px 0;
  justify-content: space-between;
  position: relative;

  & > ${AsideContentCallout} {
    right: 55px;
    top: 45px;
  }
`;
export default (_a) => {
    var { toggleA, toggleB, toggleCondition, toggleCallback, asideContent } = _a, props = __rest(_a, ["toggleA", "toggleB", "toggleCondition", "toggleCallback", "asideContent"]);
    return (_jsxs(ToggleContainer, { children: [_jsx(Radio, Object.assign({ "data-testid": `change-plan:${toggleA}-radio-toggle`, checked: !toggleCondition, label: toggleA, onChange: () => {
                    toggleCallback(!toggleCondition);
                } }, props)), _jsx(Radio, Object.assign({ "data-testid": `change-plan:${toggleB}-radio-toggle`, checked: toggleCondition, label: toggleB, onChange: () => {
                    toggleCallback(!toggleCondition);
                } }, props)), _jsx(AsideContentCallout, Object.assign({ size: "xs" }, { children: asideContent }))] }));
};
//# sourceMappingURL=ab-content-toggle.js.map